/* HMX V49 — safe sticky-local normalizer. Never drives or rewrites the main product form. */
(function () {
  'use strict';

  var ROOT = 'sticky-atc.sticky-atc:not(.hmx-universal-sticky-atc)';
  var initialized = new WeakSet();
  var buttonObservers = new WeakMap();

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function stripIds(node) {
    if (!node) return;
    if (node.removeAttribute) node.removeAttribute('id');
    Array.prototype.forEach.call(node.querySelectorAll ? node.querySelectorAll('[id]') : [], function (child) {
      child.removeAttribute('id');
    });
  }

  function productInfo() {
    return document.querySelector('product-info, .main-product__info-container, .product__info-container');
  }

  function mainNode(selector) {
    var info = productInfo();
    return info ? info.querySelector(selector) : null;
  }

  function sourceImage() {
    return document.querySelector(
      'product-media-gallery .product__media-item.is-active img,' +
      'product-media-gallery .product__media-item[aria-hidden="false"] img,' +
      'product-media-gallery img,' +
      '.product__media-list .product__media-item.is-active img,' +
      '.product__media-list img'
    );
  }

  function syncImage(target) {
    var source = sourceImage();
    if (!source || !target) return;
    var url = source.currentSrc || source.src;
    if (url && target.src !== url) target.src = url;
    if (source.srcset) target.srcset = source.srcset;
    if (source.sizes) target.sizes = source.sizes;
    target.alt = source.alt || '';
  }

  function syncPrice(target) {
    var source = mainNode('.product-page-price, [id^="price-"]');
    if (!source || !target) return;
    var clone = source.cloneNode(true);
    stripIds(clone);
    target.innerHTML = clone.innerHTML;
  }

  function normalizeButton(root) {
    var button = root.querySelector('.sticky-atc__button button, .sticky-atc__button .button');
    if (!button) return;

    Array.prototype.forEach.call(
      button.querySelectorAll('[id^="sticky-atc-price-"], .sticky-atc__button-price'),
      function (node) {
        node.style.display = 'none';
        node.setAttribute('aria-hidden', 'true');
      }
    );

    var label = button.querySelector('.sticky-atc__label__text');
    if (!label) {
      label = document.createElement('span');
      label.className = 'sticky-atc__label__text';
      (button.querySelector('.sticky-atc__label') || button).appendChild(label);
    }

    var soldOut = button.disabled || button.getAttribute('aria-disabled') === 'true';
    var text = soldOut ? 'SOLD OUT' : 'ADD TO CART';
    if (clean(label.textContent) !== text) label.textContent = text;
    button.setAttribute('aria-label', text);

    if (!buttonObservers.has(button)) {
      var observer = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          normalizeButton(root);
        });
      });
      observer.observe(button, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
      buttonObservers.set(button, observer);
    }
  }

  function applyPresentation(root) {
    root.classList.add(
      'hmx-native-sticky-unified',
      'sticky-atc--mobile-no-badge',
      'sticky-atc--small-mobile-select',
      'color-background-1'
    );
    root.classList.remove(
      'sticky-atc--desktop-no-badge',
      'sticky-atc--mobile-transparent',
      'sticky-atc--desktop-transparent'
    );
    Array.prototype.slice.call(root.classList).forEach(function (className) {
      if (/^color-/.test(className) && className !== 'color-background-1') {
        root.classList.remove(className);
      }
    });
    root.setAttribute('data-after-scroll', 'true');

    var container = root.querySelector('.sticky-atc-container');
    if (!container) return;
    container.classList.add('sticky-atc--mobile-btn-full');
    container.classList.remove('sticky-atc--desktop-btn-full');

    var left = root.querySelector('.sticky-atc__left');
    if (!left) {
      left = document.createElement('div');
      left.className = 'sticky-atc__left';
      container.insertBefore(left, root.querySelector('.sticky-atc__button') || null);
    }
    left.classList.remove('desktop-hidden');

    var content = left.querySelector('.sticky-atc__left__content');
    if (!content) {
      content = document.createElement('div');
      content.className = 'sticky-atc__left__content';
      left.insertBefore(content, left.firstChild || null);
    }
    content.classList.remove('desktop-hidden');

    var imageWrap = root.querySelector('.sticky-atc__image');
    if (!imageWrap && sourceImage()) {
      imageWrap = document.createElement('div');
      imageWrap.className = 'sticky-atc__image mobile-hidden';
      var image = document.createElement('img');
      image.loading = 'lazy';
      image.width = 80;
      image.height = 80;
      imageWrap.appendChild(image);
      container.insertBefore(imageWrap, left);
    }
    if (imageWrap) {
      imageWrap.classList.add('mobile-hidden');
      imageWrap.classList.remove('desktop-hidden');
      syncImage(imageWrap.querySelector('img'));
    }

    var sourceTitle = mainNode('.product__title h1, h1.product__title, h1');
    var title = content.querySelector('.sticky-atc__title');
    if (!title && sourceTitle) {
      title = document.createElement('h4');
      title.className = 'sticky-atc__title mobile-hidden';
      content.insertBefore(title, content.firstChild || null);
    }
    if (title) {
      title.classList.add('mobile-hidden');
      title.classList.remove('desktop-hidden');
      if (sourceTitle) title.textContent = clean(sourceTitle.textContent);
    }

    var price = content.querySelector('.sticky-atc__price');
    if (!price && mainNode('.product-page-price, [id^="price-"]')) {
      price = document.createElement('div');
      price.className = 'sticky-atc__price';
      content.appendChild(price);
    }
    if (price) {
      price.classList.remove('desktop-hidden');
      syncPrice(price);
    }

    normalizeButton(root);
  }

  function optionParts(option) {
    return String(
      option.getAttribute('data-options') ||
      (option.dataset && option.dataset.options) ||
      option.value ||
      ''
    ).split(',').map(clean);
  }

  function optionNames(count) {
    var names = [];
    var mainPicker = document.querySelector('variant-selects');
    if (mainPicker) {
      Array.prototype.forEach.call(mainPicker.querySelectorAll('.product-form__input'), function (group, index) {
        var label = group.querySelector('legend, label:not([for])');
        var text = label ? clean(label.textContent).replace(/:\s*$/, '') : '';
        if (text) names[index] = text;
      });
    }
    for (var index = 0; index < count; index += 1) {
      if (!names[index]) names[index] = 'Option ' + (index + 1);
    }
    return names;
  }

  function exactCombination(combinations, values) {
    return combinations.find(function (item) {
      if (item.disabled || item.parts.length !== values.length) return false;
      return item.parts.every(function (part, index) {
        return part === values[index];
      });
    });
  }

  function nearestCombination(combinations, values, changedIndex) {
    var exact = exactCombination(combinations, values);
    if (exact) return exact;

    var candidates = combinations.filter(function (item) {
      return !item.disabled && item.parts[changedIndex] === values[changedIndex];
    });

    candidates.sort(function (a, b) {
      var aScore = 0;
      var bScore = 0;
      values.forEach(function (value, index) {
        if (index !== changedIndex && a.parts[index] === value) aScore += 1;
        if (index !== changedIndex && b.parts[index] === value) bScore += 1;
      });
      return bScore - aScore;
    });

    return candidates[0] || combinations.find(function (item) { return !item.disabled; }) || combinations[0];
  }

  function updateAvailability(selects, combinations) {
    var selected = selects.map(function (select) { return select.value; });
    selects.forEach(function (select, optionIndex) {
      Array.prototype.forEach.call(select.options, function (option) {
        option.disabled = !combinations.some(function (item) {
          if (item.disabled || item.parts[optionIndex] !== option.value) return false;
          return selected.every(function (value, compareIndex) {
            return compareIndex === optionIndex || !value || item.parts[compareIndex] === value;
          });
        });
      });
    });
  }

  function buildStickyLocalAdapter(root, picker, original) {
    if (root.querySelector('.hmx-unified-native-picker')) return;

    var combinations = Array.prototype.map.call(original.options, function (option) {
      return {
        value: option.value,
        parts: optionParts(option),
        disabled: Boolean(option.disabled),
        option: option
      };
    }).filter(function (item) {
      return item.parts.length && item.parts.some(Boolean);
    });

    if (!combinations.length) return;

    var optionCount = combinations.reduce(function (max, item) {
      return Math.max(max, item.parts.length);
    }, 0);
    var labels = optionNames(optionCount);
    var current = combinations.find(function (item) {
      return item.value === original.value || item.option.selected;
    }) || combinations.find(function (item) {
      return !item.disabled;
    }) || combinations[0];

    var wrapper = document.createElement('div');
    wrapper.className = 'hmx-unified-native-picker hmx-unified-native-picker--' + optionCount;
    wrapper.setAttribute('aria-label', 'Product options');

    var selects = [];

    for (var index = 0; index < optionCount; index += 1) {
      var field = document.createElement('label');
      field.className = 'hmx-unified-native-picker__field';

      var hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = labels[index];

      var select = document.createElement('select');
      select.className = 'hmx-unified-native-picker__select';
      select.setAttribute('aria-label', labels[index]);

      var values = [];
      combinations.forEach(function (item) {
        var value = item.parts[index];
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });

      if (current.parts[index] != null) select.value = current.parts[index];
      field.appendChild(hidden);
      field.appendChild(select);
      wrapper.appendChild(field);
      selects.push(select);
    }

    picker.parentNode.insertBefore(wrapper, picker);
    picker.classList.add('hmx-unified-native-picker__source');
    picker.classList.remove('mobile-hidden', 'desktop-hidden');
    picker.setAttribute('aria-hidden', 'true');

    function selectCombination(combination, dispatch) {
      if (!combination) return;
      selects.forEach(function (select, index) {
        if (combination.parts[index] != null) select.value = combination.parts[index];
      });
      updateAvailability(selects, combinations);

      if (original.value !== combination.value) {
        original.value = combination.value;
      }
      if (dispatch) {
        original.dispatchEvent(new Event('input', { bubbles: true }));
        original.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    selects.forEach(function (select, changedIndex) {
      select.addEventListener('change', function () {
        var values = selects.map(function (item) { return item.value; });
        selectCombination(nearestCombination(combinations, values, changedIndex), true);
      });
    });

    original.addEventListener('change', function () {
      var combination = combinations.find(function (item) {
        return item.value === original.value;
      });
      selectCombination(combination, false);
      window.setTimeout(function () {
        applyPresentation(root);
      }, 30);
    });

    selectCombination(current, false);
  }

  function setupPicker(root) {
    var separate = root.querySelector('secondary-variant-select-separate');
    if (separate) {
      separate.classList.add('hmx-unified-native-separate');
      separate.classList.remove('mobile-hidden', 'desktop-hidden');
      return;
    }

    var combined = root.querySelector('secondary-variant-select');
    if (!combined) return;
    var original = combined.querySelector('select.sticky-atc__variant-select, select');
    if (original && original.options && original.options.length) {
      buildStickyLocalAdapter(root, combined, original);
    }
  }

  function init(root) {
    if (!root || !root.isConnected) return;
    applyPresentation(root);
    setupPicker(root);
    initialized.add(root);
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches(ROOT)) init(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT), init);
  }

  function start() {
    scan(document);
    window.setTimeout(function () { scan(document); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
